import Vue from 'vue';
import VueI18n from 'vue-i18n';
import zhCN from './zh-CN';
import zhHK from './zh-HK';
import en from './en';

import moment from 'moment';
import 'moment/locale/zh-cn';
import 'moment/locale/zh-tw';
import 'moment/locale/en-gb';

Vue.use(VueI18n);

// 支持的语言列表
export const supportedLocales = ['zh-CN', 'zh-HK', 'en'];

// 默认语言
export const defaultLocale = 'zh-CN';

// 从 localStorage 获取保存的语言，如果没有则使用默认语言
const getSavedLocale = () => {
	try {
		const saved = localStorage.getItem('locale');
		return saved && supportedLocales.includes(saved) ? saved : defaultLocale;
	} catch (e) {
		return defaultLocale;
	}
};

// 创建 i18n 实例
const i18n = new VueI18n({
	locale: getSavedLocale(),
	fallbackLocale: defaultLocale,
	messages: {
		'zh-CN': zhCN,
		'zh-HK': zhHK,
		en: en
	},
	silentTranslationWarn: true
});

// 切换语言
export const setLocale = locale => {
	if (!supportedLocales.includes(locale)) {
		console.warn(`Unsupported locale: ${locale}, falling back to ${defaultLocale}`);
		locale = defaultLocale;
	}
	i18n.locale = locale;
	localStorage.setItem('locale', locale);

	switch (locale) {
		case 'zh-CN':
			moment.locale('zh-cn');
			break;
		case 'zh-HK':
			moment.locale('zh-tw');
			break;
		case 'en':
			moment.locale('en-gb');
			break;
		default:
			moment.locale('zh-cn');
			break;
	}
};

export default i18n;
